import { CompleteQuery } from 'modules/queryBuilder/types';
import { useCatalogPreviewContext } from '../contexts/CatalogPreviewContext';

export const useSubmitForPreview = () => {
  const { openPreview, isLoading, previewResults } = useCatalogPreviewContext();
  return (searchQuery: CompleteQuery) => {
    if (isLoading) return;
    previewResults(searchQuery);
    openPreview();
  };
};
